import { Injectable } from '@angular/core';
import { BaseProvider } from '../../shared/providers/base-provider';
import { LayerNotifier } from '../notifiers/layer-notifier';
import { LayerState } from '../states/layer-state';

@Injectable({ providedIn: 'root' })
export class LayerProvider extends BaseProvider<LayerNotifier, LayerState> {
  constructor() {
    super(LayerNotifier);
  }
}
